import React from 'react';
import { Card } from 'components/cards/Card';
import { Text } from 'components/typography';
import { ShouldRender } from 'components/ShouldRender';
import styles from './styles.module.scss';

export const BookingCard = ({
  name,
  date,
  from,
  to,
  address,
  endDate,
  showRange,
  icon,
}) => (
  <Card
    grey
    className={styles.card}
  >
    <div className={styles.icon}>{icon}</div>

    <div>
      <Text
        bold
        size={18}
      >
        {name}
      </Text>

      <ShouldRender condition={!showRange}>
        <div className={styles.inlineText}>
          <Text
            size={15}
            bold
          >
            {date}
          </Text>
          <Text size={15}>
            {from} - {to}
          </Text>
        </div>
      </ShouldRender>

      <ShouldRender condition={showRange}>
        <div className={styles.inlineText}>
          <Text size={15}>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              {date}
            </span>{' '}
            {from} -
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              {` ${endDate}`}
            </span>{' '}
            {to}
          </Text>
        </div>
      </ShouldRender>

      <Text size={15}>{address}</Text>
    </div>
  </Card>
);
